import { EventBus } from '../../../system/services/event/event.bus';

export const TemplateViewEventBus = new EventBus('template.view');
